var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAssimetriaInferior(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4062 5.39062C11 5.79688 10.5312 6 10 6C9.46875 6 9 5.79688 8.59375 5.39062C8.1875 4.98438 7.98438 4.51562 7.98438 3.98438C7.98438 3.45312 8.1875 3 8.59375 2.625C9 2.21875 9.46875 2.01562 10 2.01562C10.5312 2.01562 11 2.21875 11.4062 2.625C11.8125 3 12.0156 3.45312 12.0156 3.98438C12.0156 4.51562 11.8125 4.98438 11.4062 5.39062ZM18.4844 6L19 8.01562C17.4375 8.45312 15.4375 8.78125 13 9V21.9844H10.9844V15.9844H9.01562V21.9844H7V9C4.5625 8.78125 2.5625 8.45312 1 8.01562L1.51562 6C3.95312 6.65625 6.78125 6.98438 10 6.98438C13.2188 6.98438 16.0469 6.65625 18.4844 6Z",
    fill: "#ABADB7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 13H7V21.9844H9.01562V15.9844H10.9844V21.9844H13V13Z",
    fill: "#00D084"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 13H7V16V22H9V16H10V13H9Z",
    fill: "#63677A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssimetriaInferior);
export default __webpack_public_path__ + "static/media/assimetria_inferior.049ff1f8df5f434f59c586dfd948418f.svg";
export { ForwardRef as ReactComponent };